module.exports = __webpack_public_path__ + "img/icon_main1.ac6bff2d.png";